module.exports = __webpack_public_path__ + "img/account_revenue.3319e876.svg";